<template>
  <div v-bind="$attrs" class="dropdown-divider" />
</template>

